<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        icon="chevron-back"
        defaultHref="tabs/jobs"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Last Minute job</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="job">
  <div
    [ngSwitch]="job?.status?.workerStatus"
    class="ion-margin-top mable-section"
  >
    <ng-container
      *ngIf="!job?.workerFields?.allowActions?.reply && job?.status?.workerStatus === 'pending'; else multioffers"
    >
      <div class="sub-section">
        <p class="ion-margin-horizontal">Job now {{job?.status?.clientStatusDescription?.toLowerCase()}}.</p>
      </div>
    </ng-container>
    <ng-template #multioffers>
      <div
        class="sub-section"
        *ngSwitchCase="'pending'"
      >
        <mable-heading heading="h3">Offers</mable-heading>
        <p class="ion-margin-horizontal">
          You’ve been selected as an early candidate. Reply as soon as you can; only the first 5 offers will be sent.
        </p>
      </div>
      <div
        class="sub-section"
        *ngSwitchCase="'declined'"
      >
        <mable-heading heading="h3">Offers</mable-heading>
        <p class="ion-margin-horizontal">This job has received 5 offers and is now closed.</p>
      </div>

      <ng-container *ngSwitchCase="'offered'">
        <div class="ion-margin-horizontal">
          <div class="notification">
            <ion-icon name="checkmark-circle"></ion-icon>
            <div class="message">
              <p>Offer Sent</p>
              <p>{{form.get('rate').value}} per Hour</p>
            </div>
          </div>
          <p class="body-normal-16">An offer is a commitment to provide the support if accepted by the Client.</p>
          <p class="body-normal-16 ion-no-margin">
            You will be notified of the Client’s decision at least 2 hours in advance of the starting time.
          </p>
        </div>
        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <mable-button
                category="outline"
                expand="block"
                (onClick)="withdraw()"
                >Withdraw Offer</mable-button
              >
            </ion-col>
            <ion-col size="6">
              <mable-button
                category="orange-500"
                expand="block"
                (onClick)="close()"
                >Close</mable-button
              >
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-container>
    </ng-template>
  </div>
  <div class="mable-section">
    <!-- not display <app-rates-info-banner> (that is inside <app-flex-job-summary>) in case the rate input is shown to match the desired design -->
    <app-flex-job-summary
      [job]="job"
      [shouldShowRatesInfoBanner]="!showOfferBlock"
      bgColor="white-0"
    ></app-flex-job-summary>
  </div>
  <form
    [formGroup]="form"
    novalidate
  >
    <div
      class="mable-section"
      *ngIf="showOfferBlock"
    >
      <mable-heading heading="h3">Make an offer</mable-heading>
      <div class="sub-section">
        <mable-input [label]="'Tell ' + job?.client?.truncatedName + ' why you would be most suited'">
          <ion-textarea
            autocapitalize="sentences"
            autosize
            rows="7"
            name="consumer_description"
            class="response"
            formControlName="comment"
            placeholder="Type a response..."
            autocomplete="on"
            autocorrect="on"
            spellcheck="true"
          >
          </ion-textarea>
        </mable-input>
      </div>
      <ng-container *ngIf="(defaultServiceCategory$ | async) as defaultServiceCategory">
        <app-rates-info-banner
          *ngIf="defaultServiceCategory?.length"
          [isCarer]="isCarer"
          shouldShowRatesInfoBanner="false"
        ></app-rates-info-banner>
      </ng-container>

      <last-minute-job-rate
        [job]="job"
        (rateChange)="updateFormProperties($event)"
      />

      <div class="sub-section">
        <mable-banner category="callout">
          <ng-container class="content">
            <p>An offer is a commitment to provide the support if accepted by the client.</p>
          </ng-container>
        </mable-banner>
        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <mable-button
                category="outline"
                expand="block"
                (onClick)="showOfferBlock = false"
                >Cancel</mable-button
              >
            </ion-col>
            <ion-col size="6">
              <mable-button
                category="orange-500"
                expand="block"
                (onClick)="offer()"
                >Send offer</mable-button
              >
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </form>
  <ion-grid
    *ngIf="job?.status?.workerStatus === 'pending' && !showOfferBlock && !job?.workerFields?.userHasBlocked && !job?.workerFields?.userIsBlocked && job?.workerFields?.allowActions?.reply && job?.workerFields?.allowActions?.decline"
  >
    <ion-row>
      <ion-col size="6">
        <mable-button
          category="outline"
          expand="block"
          (onClick)="decline()"
          >Decline Job</mable-button
        >
      </ion-col>
      <ion-col size="6">
        <mable-button
          category="orange-500"
          expand="block"
          (onClick)="showOfferBlock = true"
        >
          Make an offer
        </mable-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- When you have blocked the other user -->
  <mable-tip
    *ngIf="job?.workerFields?.userHasBlocked"
    [heading]="'You have Blocked ' + job?.client?.truncatedName"
  >
  </mable-tip>

  <!-- When you have been blocked by the other user -->
  <mable-tip
    *ngIf="job?.workerFields?.userIsBlocked && !job?.workerFields?.userHasBlocked"
    [heading]="job?.client?.truncatedName + ' has disabled messaging'"
    icon="home"
  >
  </mable-tip>
</ion-content>
